// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  /** `ng serve` / `npm start` use this file (not environment.prod.ts). */
  baseUrl: 'https://api.3efreet.com/api/v1/', // live API (local UI testing)
  // baseUrl: 'http://localhost:3119/api/v1/', // local backend only
  // baseUrl: 'https://3efreetstg-be.siplsolutions.com/api/v1/', // staging
  // baseUrl: 'http://15.207.150.38:3112/api/v1/',
  /** Optional uploads host; when empty, uses origin of baseUrl (same as API server serving /uploads). */
  baseUrlUploads: '',
  production: false
};
